module.exports = __webpack_public_path__ + "media/src/components/HomePage/Benefit/instant-quote-83969d15914e475eb3c820630bb455a6.png";